import React, { FC } from 'react';

import { TableCell } from '@material-ui/core';
import format from 'date-fns/format';
import parse from 'date-fns/parse';

import { CellProps } from '../../../const';

const DateCell: FC<CellProps> = ({ row, k, styles, align }) => {
  const date = row[k] && parse(row[k], 'yyyy-MM-dd HH:mm:ss', new Date());
  return (
    <TableCell key={k} className={styles.contentCell} align={align} title={date && date.toString()}>
      {date && format(date, 'HH:mm E, do MMM yyyy')}
    </TableCell>
  );
};

export default DateCell;
